import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()((theme) => ({
    lastCols: {
        width: "100px",
    },
}))
